import * as XLSX from 'xlsx';

interface ExcelSheet {
  name: string;
  headers: string[];
  data: any[][];
}

export const exportToExcel = (filename: string, sheets: ExcelSheet[]) => {
  const workbook = XLSX.utils.book_new();
  
  sheets.forEach(sheet => {
    const worksheet = XLSX.utils.aoa_to_sheet([sheet.headers, ...sheet.data]);
    XLSX.utils.book_append_sheet(workbook, worksheet, sheet.name);
  });
  
  const timestamp = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(workbook, `${filename}_${timestamp}.xlsx`);
};

export const exportSingleSheet = (filename: string, headers: string[], data: any[][]) => {
  exportToExcel(filename, [{ name: 'Sheet1', headers, data }]);
};